import { Stack } from "@mui/material";
import { BottomLinks } from "./leftPanel";

/**The footer component
 * @param {Object} props props
 * @param {Object} props.sx the styles to add to the component
 * @param {boolean} props.noBg whether to have a background color or not
 */
const Footer = ({ sx, noBg = false }) => {
  return (
    <footer
      style={{
        backgroundColor: !noBg && "rgb(50,50,50)",
        ...sx,
      }}
    >
      <Stack sx={{ alignItems: "center", p: 3 }}>
        <BottomLinks black={noBg} />
      </Stack>
    </footer>
  );
};
export default Footer;
